/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { CourierUser } from './CourierUser';
/**
 * 
 * @export
 * @interface AccessToken
 */
export interface AccessToken {
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    id: string;
    /**
     * time to live in seconds (2 weeks by default)
     * @type {number}
     * @memberof AccessToken
     */
    ttl?: number;
    /**
     * Array of scopes granted to this access token.
     * @type {Array<string>}
     * @memberof AccessToken
     */
    scopes?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof AccessToken
     */
    created?: Date;
    /**
     * 
     * @type {number}
     * @memberof AccessToken
     */
    userId?: number;

    user?: CourierUser;
}

/**
 * Check if a given object implements the AccessToken interface.
 */
export function instanceOfAccessToken(value: object): value is AccessToken {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function AccessTokenFromJSON(json: any): AccessToken {
    return AccessTokenFromJSONTyped(json, false);
}

export function AccessTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessToken {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'ttl': json['ttl'] == null ? undefined : json['ttl'],
        'scopes': json['scopes'] == null ? undefined : json['scopes'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function AccessTokenToJSON(json: any): AccessToken {
    return AccessTokenToJSONTyped(json, false);
}

export function AccessTokenToJSONTyped(value?: AccessToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ttl': value['ttl'],
        'scopes': value['scopes'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'userId': value['userId'],
    };
}

